module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, _vm._l((_vm.products), function(product, index) {
    return _c('div', {
      key: product.id,
      staticClass: "flex items-center border-b p-3 justify-between"
    }, [_c('div', {
      staticClass: "flex items-center"
    }, [_c('div', {
      staticClass: "w-24"
    }, [_c('img', {
      attrs: {
        "src": product.imageUrl,
        "width": "55px",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex flex-col"
    }, [_c('div', [_vm._v(_vm._s(product.name))]), _vm._v(" "), _c('copy-text', [_c('router-link', {
      staticClass: "text-grey-darker text-xs no-underline hover:underline",
      attrs: {
        "to": ("/products/" + (product.productId))
      }
    }, [_vm._v(_vm._s(product.model))])], 1)], 1)]), _vm._v(" "), _c('div', [_c('button', {
      on: {
        "click": function($event) {
          return _vm.removeProductFromList(product.id, index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash text-grey-dark"
    })])])])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71678885","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cart/CartProduct.vue
// module id = 633
// module chunks = 66